import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class GenerateExcelReportOperationalDiary {
    exportExcel(data, starterDate, endDate) {
        let option = {};  // La opción representa el archivo de Excel
        let reportDetails = this.reportDetails(data, starterDate, endDate);
        option.fileName = 'DIARIO_OPERACIONES' + moment(endDate).format('DD-MM-YYYY');  // Nombre del archivo Excel
        console.log("DOCEXCEL", data)
        option.datas = [
            {
                sheetData: reportDetails.data,  // Fuente de datos en archivo Excel
                sheetName: option.fileName,  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    reportDetails(details, starterDate, endDate) {
        let dataTable = [];  // Contenido de datos en archivo Excel
        let tituloNombreEmpresa = this.generarTituloPerfil();//Titulo Nombre de Empresa
        let titulosCierreCaja = this.generarTituloConVacios();//Titulos del Recibo de Caja
        let tituloFechaInicial = this.generarTituloFechaInicial(starterDate);
        let tituloFechaFinal = this.generarTituloFechaFinal(endDate);

        dataTable.push(tituloNombreEmpresa);
        dataTable.push(titulosCierreCaja);
        dataTable.push(tituloFechaInicial);
        dataTable.push(tituloFechaFinal);
        let titlesExcel = this.generateTitlesInvoiceExcel();//Titulos de la Factura
        dataTable.push(titlesExcel);
        
        for (let i = 0; i < details.length; i++) {
            let detailExcel = this.generateInvoiceDetailBoxs(details[i], i);//Detalles de la FActura
            dataTable.push(detailExcel);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTituloPerfil() {
        let perfil = sessionStorage.getItem('perfil');
        let Titulos = {
            '1': sessionStorage.getItem('nombre_empresa'),
        }
        return Titulos;
    }

    generarTituloConVacios() {
        let Titulos = {
            '1': "Diario de Operaciones",
        }
        return Titulos;
    }

    generarTituloFechaInicial(fecha_inicial) {
        let Titulos = {
            '1': 'Fecha Inicial',
            '2': moment(fecha_inicial).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generarTituloFechaFinal(fecha_final) {
        let Titulos = {
            '1': 'Fecha Final',
            '2': moment(fecha_final).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generateTitlesInvoiceExcel() {
        let Titulos = {
            '1': 'N°',
            '2': 'REGISTRO',
            '3': 'FECHA ATENCIÓN',
            '4': 'HORA DE ADMON',
            '5': 'NOMBRE DEL PACIENTE',
            '6': 'ID*',
            '7': 'EDAD',
            '8': 'CUPS',
            '9': 'SERVICIO',
            '10': 'ACTIVIDAD EN MBq',
            '11': 'EMBARAZO',
            '12': 'OBSERVACIÓN',
            '13': 'PESO',
            '14': 'TALLA',
            '15': 'ENTIDAD',
            '16': 'TELEFONO'
        }
        return Titulos;
    }

    generateInvoiceDetailBoxs(details, i) {
        let Casillas = {
            '1':    i+1,
            '2':    details.num_documento != null && details.num_documento != undefined ? details.num_documento : "",
            '3':    details.fecha_cita != null && details.fecha_cita != undefined ? moment(details.fecha_cita).format('DD/MM/YYYY') : "",
            '4':    details.fecha_cita != null && details.fecha_cita != undefined ? moment(details.fecha_cita).format('h:mm:ss a') : "",
            '5':    details.nombre_paciente != null && details.nombre_paciente != undefined ? details.nombre_paciente : "",
            '6':    details.num_documento != null && details.num_documento != undefined ? details.num_documento : "",
            '7':    details.edad != null && details.edad != undefined ? details.edad + details.unidad_medida_edad : "",
            '8':    details.cups_servicio != null && details.cups_servicio != undefined ? details.cups_servicio : "",
            '9':   details.nombre_servicio != null && details.nombre_servicio != undefined ? details.nombre_servicio : "",
            '10':   details.actividad_mbq != null && details.actividad_mbq != undefined ? details.actividad_mbq : "",
            '11':   details.embarazo != null && details.embarazo != undefined ? details.embarazo : "No",
            '12':   details.observacion != null && details.observacion != undefined ? details.observacion : "",
            '13':   details.peso != null && details.peso != undefined ? details.peso : "",
            '14':   details.talla != null && details.talla != undefined ? details.talla : "",
            '15':   details.nombre_entidad != null && details.nombre_entidad != undefined ? details.nombre_entidad : "",
            '16':   details.celular != null && details.celular != undefined ? details.celular : "",
        }
        return Casillas;
    }

}
export default new GenerateExcelReportOperationalDiary();